module.exports = __webpack_public_path__ + "static/img/1.3db9ae55.png";